"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _times = _interopRequireDefault(require("@remote-com/norma/icons/times.svg"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ButtonNorma = require("../../ButtonNorma");

var _motion = require("../../../style/motion");

var __jsx = _react["default"].createElement;
var ButtonCloseStyled = (0, _styledComponents["default"])(_ButtonNorma.ButtonIcon).withConfig({
  displayName: "ButtonClose__ButtonCloseStyled",
  componentId: "sc-7ok1ym-0"
})(["", ";--iconColor:red;fill:var(--svgColor);&:hover,&:focus{transform:rotate(90deg);--iconColor:green;}"], (0, _motion.sharedTransition)('transform'));

var ButtonClose = function ButtonClose(props) {
  return __jsx(ButtonCloseStyled, (0, _extends2["default"])({
    variant: "ghost",
    Icon: _times["default"]
  }, props));
};

var _default = ButtonClose;
exports["default"] = _default;